__turbopack_context__.v({
  "edgeBottom": "_8vuJ6G_edgeBottom",
  "edgeLeft": "_8vuJ6G_edgeLeft",
  "edgeRight": "_8vuJ6G_edgeRight",
  "edgeTop": "_8vuJ6G_edgeTop",
  "layer": "_8vuJ6G_layer",
  "layer0": "_8vuJ6G_layer0",
  "layer1": "_8vuJ6G_layer1",
  "layer2": "_8vuJ6G_layer2",
  "layer3": "_8vuJ6G_layer3",
  "layer4": "_8vuJ6G_layer4",
  "wash": "_8vuJ6G_wash",
});
